<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">POUR JONAH LOWELL CHURCHILL,<br/>QUI POURRAIT BIEN ÊTRE LE JUMEAU MALÉFIQUE</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?41ceb594